import {
  Box,
  Button,
  Chip, Divider, Grid, TextField, Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import useChartFilter from '../../hooks/useChartFilter';
import useFetchApi from '../../hooks/useFetchApi';
import { CultivationCyclePopulatedSchema, GetCultivationCyclesBySectorResponse } from '../../requests/api/apiTypes';
import useStyles from './styles';

type CultivationCycleWithUUID = Omit<CultivationCyclePopulatedSchema, 'phenologicalStates'>;

function ChartFilter({
  sectorId,
  extraSelector,
  show = true,
}: {
  sectorId: string,
  extraSelector?: React.ReactNode,
  show?: boolean,
}) {
  const classes = useStyles();
  const {
    tempStartDate,
    tempEndDate,
    selectedInterval,
    setTempStartDate,
    setTempEndDate,
    handleApplyDates,
    handleIntervalSelect,
  } = useChartFilter();

  const [cultivationCycles, setCultivationCycles] = useState<CultivationCycleWithUUID[]>([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedCycleId, setSelectedCycleId] = useState<string>('default');
  // eslint-disable-next-line no-unused-vars
  const [selectedStateId, setSelectedStateId] = useState<string>('default');

  const { data } = useFetchApi<GetCultivationCyclesBySectorResponse>({
    modelEndpoint: 'cultivationCycleSectorDetail',
    modelName: 'cultivationCycleSector',
    id: sectorId,
    dependencies: [sectorId],
  });

  useEffect(() => {
    if (data) {
      const cyclesWithStateIds = data.cultivationCycles.map((cycle) => ({
        ...cycle,
      }));
      setCultivationCycles(cyclesWithStateIds);
    }
  }, [data]);

  // eslint-disable-next-line no-unused-vars
  const selectedCycle = cultivationCycles.find((cycle) => cycle.id === selectedCycleId);
  const today = dayjs().format('YYYY-MM-DD');

  if (!tempStartDate || !tempEndDate) {
    return null;
  }

  return show ? (
    <Box>
      <Divider className={classes.divider} />
      <Grid container spacing={2}>
        <Grid item sm={12} md={3}>
          <Box className={classes.selectFieldsContainer}>
            {extraSelector || null}
            {/* <TextField
              className={classes.selectField}
              label="Ciclo de cultivo"
              value={selectedCycleId}
              select
              onChange={setDatesOnCultivationCycle}
              variant="standard"
              disabled={cultivationCycles.length === 0}
            >
              <MenuItem value="default">Seleccionar</MenuItem>
              {cultivationCycles.map((cycle) => (
                <MenuItem key={cycle.id} value={cycle.id}>
                  {cycle.name}
                </MenuItem>
              ))}
            </TextField> */}

            {/* <TextField
              className={classes.selectField}
              label="Estado fenológico"
              value={selectedStateId}
              select
              onChange={setDatesOnPhenologicalState}
              variant="standard"
              disabled={!selectedCycle || selectedCycleId === 'default'}
            >
              <MenuItem value="default">Seleccionar</MenuItem>
              {selectedCycle?.phenologicalStates.map((state) => (
                <MenuItem key={state.uuid} value={state.uuid}>
                  {state.name}
                </MenuItem>
              ))}
            </TextField> */}
          </Box>
        </Grid>

        <Grid item sm={12} md={5}>
          <Typography className={classes.chipsLabel}>
            Intervalos de tiempo
          </Typography>
          <Box className={classes.chipsContainer}>
            <Chip
              key='1-day'
              color={selectedInterval === '1-day' ? 'primary' : undefined}
              label="1 día"
              onClick={() => handleIntervalSelect('1-day')}
              size='small'
              className={classes.layoutMapChip}
            />
            <Chip
              key='1-week'
              color={selectedInterval === '1-week' ? 'primary' : undefined}
              label="1 semana"
              onClick={() => handleIntervalSelect('1-week')}
              size='small'
              className={classes.layoutMapChip}
            />
            <Chip
              key='2-weeks'
              color={selectedInterval === '2-weeks' ? 'primary' : undefined}
              label="2 semanas"
              onClick={() => handleIntervalSelect('2-weeks')}
              size='small'
              className={classes.layoutMapChip}
            />
            <Chip
              key='1-month'
              color={selectedInterval === '1-month' ? 'primary' : undefined}
              label="1 mes"
              onClick={() => handleIntervalSelect('1-month')}
              size='small'
              className={classes.layoutMapChip}
            />
            <Chip
              key='3-months'
              color={selectedInterval === '3-months' ? 'primary' : undefined}
              label="3 meses"
              onClick={() => handleIntervalSelect('3-months')}
              size='small'
              className={classes.layoutMapChip}
            />
            <Chip
              key='6-months'
              color={selectedInterval === '6-months' ? 'primary' : undefined}
              label="6 meses"
              onClick={() => handleIntervalSelect('6-months')}
              size='small'
              className={classes.layoutMapChip}
            />
          </Box>
        </Grid>

        <Grid item sm={12} md={4}>
          <Box className={classes.selectFieldsContainer}>
            <TextField
              className={classes.selectField}
              label="Fecha de inicio"
              type="date"
              value={tempStartDate}
              onChange={(e) => setTempStartDate(e.target.value)}
              variant="standard"
              InputLabelProps={{ shrink: true }}
              inputProps={{
                max: today,
              }}
            />
            <TextField
              className={classes.selectField}
              label="Fecha de fin"
              type="date"
              value={tempEndDate}
              onChange={(e) => setTempEndDate(e.target.value)}
              variant="standard"
              InputLabelProps={{ shrink: true }}
              inputProps={{
                max: today,
              }}
            />
            <Button
              className={classes.filterButton}
              variant="contained"
              color="primary"
              onClick={handleApplyDates}
              style={{ marginTop: '16px' }}
            >
              Aplicar
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Divider className={classes.divider} />
    </Box>
  ) : null;
}

export default ChartFilter;
